import { Playground } from './classes/Playground';
import { activateGlobalCss } from './tools/activateGlobalCss';

export default Playground;

activateGlobalCss();
